/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy } from './get-organizations-bills200-response-inner-latest-status-status-changed-by';

/**
 * 
 * @export
 * @interface GetOrganizationsBills200ResponseInnerLatestStatus
 */
export interface GetOrganizationsBills200ResponseInnerLatestStatus {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatus
     */
    'status'?: GetOrganizationsBills200ResponseInnerLatestStatusStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatus
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatus
     */
    'statusChangedAt'?: string;
    /**
     * 
     * @type {GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy}
     * @memberof GetOrganizationsBills200ResponseInnerLatestStatus
     */
    'statusChangedBy'?: GetOrganizationsBills200ResponseInnerLatestStatusStatusChangedBy;
}

export const GetOrganizationsBills200ResponseInnerLatestStatusStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type GetOrganizationsBills200ResponseInnerLatestStatusStatusEnum = typeof GetOrganizationsBills200ResponseInnerLatestStatusStatusEnum[keyof typeof GetOrganizationsBills200ResponseInnerLatestStatusStatusEnum];


